// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 32-knowledge.md
import * as React from 'react';

import { usePageTitle } from '@/components/app-shell/AppShell';
import { Eyebrow } from '@/components/greenlight/Eyebrow';
import { EntriesCard } from '@/components/knowledge/EntriesCard';
import { KnowledgeEntryEditor } from '@/components/knowledge/KnowledgeEntryEditor';
import { ProposalsCard } from '@/components/knowledge/ProposalsCard';
import { useCurrentUser } from '@/lib/auth';
import type { KnowledgeScope } from '@greenlight/contract';

export function KnowledgePage(): React.JSX.Element {
  usePageTitle('Knowledge');
  const user = useCurrentUser();
  const [scope, setScope] = React.useState<KnowledgeScope>('org');
  const [openEntryId, setOpenEntryId] = React.useState<string | null>(null);
  return (
    <div className="space-y-6" data-testid="knowledge-page">
      <div>
        <Eyebrow>Knowledge base</Eyebrow>
        <h1 className="text-2xl md:text-[28px] font-semibold tracking-[-0.02em]">Knowledge</h1>
      </div>
      <ProposalsCard userRole={user?.role} />
      <EntriesCard
        scope={scope}
        onScopeChange={setScope}
        onOpenEntry={setOpenEntryId}
        userRole={user?.role}
      />
      <KnowledgeEntryEditor
        entryId={openEntryId}
        userRole={user?.role}
        onClose={() => setOpenEntryId(null)}
      />
    </div>
  );
}
